import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@ava/shared/services/routers";

export const trpc = createTRPCReact<AppRouter>();
